import { chunk, flow, map, size } from 'lodash/fp';
import { mapAsync } from '@gcc/nodash';

import axios from './axios';
import config from '../../helpers/config';

const mapItemDetail = item => ({
  config: {
    id: item.configurationId,
    type: 'GCC',
  },
  itemId: `${item.skuNumber}`,
  quantity: '1',
  location: 'DirectShip',
  type: 'sth',
});

const cartItems = items => (
  axios.post(config.thdCartApiUrl, {
    query: `mutation addToCart($cartRequest: CartInfoRequest!) {
      addToCart(cartRequest: $cartRequest) {
        cartId
        itemCount
        messages {
          type
          messageCategoryType
          correlationId
          correlationType
          longDesc
          shortDesc
        }
      }
    }`,
    variables: {
      cartRequest: {
        filterItem: true,
        localization: {
          primaryStoreZipCode: 30339,
          primaryStoreId: 121,
        },
        cartAttr: {
          essentialAccessories: true,
        },
        items: {
          delivery: map(mapItemDetail)(items),
        },
      },
    },
  })
);

const enhanceYourCalm = (calmRate, func) => async (it, idx, array) => {
  await func(it);

  if (size(array) - 1 !== idx) {
    await new Promise(r => setTimeout(r, calmRate));
  }
};

export default items => flow(
  chunk(config.thdCartBatchSize || 5),
  mapAsync(enhanceYourCalm(config.thdCartCalmRate, cartItems)),
)(items);
